module.exports = __webpack_public_path__ + "static/img/Cognitive Health Circle@2x.a6366fca.png";